/** Keep authorization intact while giving rewritten bytes a fresh browser cache key. */
export function withAssetRevision(url: string, revision?: string): string {
  if (revision === undefined) return url;
  const revised = new URL(url);
  revised.searchParams.set("workspaceRevision", revision);
  return revised.toString();
}
